import { createBrowserRouter, Navigate } from "react-router-dom";
import { routes } from "./Routes";
import { PageRoutes } from "../constants/routes";
import { RootLayout } from "./RootLayout";
import OnboardingLayout from "./OnboardingLayout";
import { AuthenticatedLayout } from "./AuthenticatedLayout";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        element: <OnboardingLayout />,
        children: [
          {
            element: <AuthenticatedLayout />,
            children: [
              ...routes,
              { path: "*", element: <Navigate to={PageRoutes.Home} replace /> },
            ],
          },
        ],
      },
    ],
  },
]);
